export default __webpack_public_path__ + "static/RootSans-14UltraItalic-d5c07599ce28483cb457ea0c325e2fd0.woff2";